module.exports = __webpack_public_path__ + "img/twism-new-logo.a652a160.svg";